import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { NormalRightarrowLine } from '@m-ui/icons';
import { Tabs } from 'm-ui';
import { paths } from 'constants/paths';
import less from './index.module.less';
// import { useGetWebAccountInfoUsingPOST } from 'query/webAccount';

const { TabPane } = Tabs;

const TrendingOverlay: React.FC = () => {
    // const intl = useIntl();
    // const { data: userInfo } = useGetWebAccountInfoUsingPOST();
    const [activeTabKey, setActiveTabKey] = useState<string>(window.location.hash);
    const onTabChange = (key: string) => {
        setActiveTabKey(key);
    };

    return (
        <div className={less.container}>
            <Tabs
                tabPosition="left"
                // tabBarStyle={{ width: '288px' }}
                activeKey={window.location.hash === activeTabKey ? activeTabKey : ''}
                onTabClick={(key, e) => {
                    e.stopPropagation();
                    if (key === 'Others') {
                        window.location.hash = paths.HOME.path;
                    } else {
                        onTabChange(key);
                        window.location.hash = key;
                    }
                }}
            >
                <TabPane
                    tab={
                        <span className={less.titleSpan}>
                            <span>
                                <FormattedMessage defaultMessage="Hashtags" />
                            </span>
                            <NormalRightarrowLine className={less.titleSpanIcon} />
                        </span>
                    }
                    key="#/trending/hashtags"
                />
                <TabPane
                    tab={
                        <span className={less.titleSpan}>
                            <span>
                                <FormattedMessage defaultMessage="Songs" />
                            </span>
                            <NormalRightarrowLine className={less.titleSpanIcon} />
                        </span>
                    }
                    key="#/trending/music"
                />
                <TabPane
                    tab={
                        <span className={less.titleSpan}>
                            <span>
                                <FormattedMessage defaultMessage="Creators" />
                            </span>
                            <NormalRightarrowLine className={less.titleSpanIcon} />
                        </span>
                    }
                    key="#/trending/creator"
                />
            </Tabs>
        </div>
    );
};

export default TrendingOverlay;
